<template>
  <div :key="activity.id" class="booking-item mb-s">
    <div class="content">
      <div class="images-container single" :class="{multiple: activity.images.length > 1, inactive: !activity.url}">
        <div class="image-placeholder" v-for="img in activity.images" :key="img">
          <img :src="img" alt="" :class="[activity.type]" />
        </div>
      </div>
      <div class="copy">
        <h3 class="mb-xs booking-name">{{ activity.name }}</h3>
        <div class="booking-unavailable" v-if="!activity.url">
          Bookings are <strong>Not Available</strong> or <strong>Not Needed</strong>
        </div>
      </div>
    </div>
    <div class="align-right">
      <slot></slot>
      <div class="price" v-if="activity.price">
        <div class="label">{{ totalPrice }}</div>
        <div class="label" v-if="additionalCaption">{{ additionalCaption }}</div>
        <div class="value">{{ activity.price }}</div>
      </div>
      <div class="action-wrapper">
        <a
          v-bind:href="activity.url"
          target="_blank"
          rel="”noreferrer”"
          noopener
          v-if="activity.url && !activity.booked"
          @mousedown="redirectToActivity(activity, $event)"
        >
          <button class="btn-action">
            Book
            <div class="icon-external-link"></div>
          </button>
        </a>
        <button class="btn-action outline" v-if="activity.booked">
          <div class="icon-check"></div>
          Booked!
        </button>
        <a
          :class="{invisible: !isBookable}"
          @click="bookActivity($event, false)"
          href="#"
          v-if="activity.booked"
          class="mark-as-booked"
        >
          <span>or <strong>mark as not booked</strong></span>
        </a>

        <a
          v-bind:href="activity.webURL"
          target="_blank"
          rel="”noreferrer”"
          noopener
          v-if="!activity.url && activity.webURL"
          @mousedown="trackDetailsClick(activity.webURL)"
        >
          <button class="btn-action btn-details">
            Details
            <ExtLinkIcon class="icon-external-link"></ExtLinkIcon>
          </button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';
import ExtLinkIcon from '../../svg/external-link.vue';
import {trackBtnClick} from '@/store/api/trackBtnClick';
import {getUserId} from '@/services/auth-shared';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {openDynamicUrl} from '../useSaveSolutionDialod';
Vue.use(VueCompositionAPI);

export default {
  name: 'BookingItem',
  components: {
    ExtLinkIcon,
  },
  props: {
    activity: {
      type: Object,
      default: () => ({
        name: '',
        id: '',
        price: '',
        img: '',
        url: '',
        guests: '',
        bookingSite: '',
        type: '',
        category: UserActivityCategoryEnum.NONE,
      }),
    },
    totalPrice: {
      type: String,
      default: 'Total Price',
    },
    additionalCaption: {
      type: String,
      default: '',
    },
    isBookable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    bookActivity(e, status) {
      e.preventDefault();
      this.$emit('book', status);
    },
    trackDetailsClick(url) {
      const userId = getUserId();
      trackBtnClick(userId, url);
    },
    redirectToActivity(activity, e) {
      this.trackDetailsClick(activity.url);
      if ([UserActivityCategoryEnum.FLIGHT, UserActivityCategoryEnum.ACCOMMODATION].includes(activity.category)) {
        e.preventDefault();
        e.stopPropagation();
        openDynamicUrl(activity.url);
        return false;
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.booking-item,
.booking-item > * {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.content {
  display: flex;
  flex-direction: row;
  gap: 22px;
  /* flex-basis: 400px; */
  align-items: center;
}
.images-container {
  width: 70px;
  height: 70px;
  flex-shrink: 0;
  position: relative;
}
.image-placeholder {
  flex-shrink: 0;
  border-radius: 10px;
  position: absolute;
  overflow: hidden;
  border: 1px solid #f1f1f1;
  background-color: white;
}
.images-container.multiple .image-placeholder {
  width: 48px;
  height: 48px;
}
.images-container.multiple .image-placeholder:first-child {
  top: 0;
  left: 0;
}

.images-container.multiple .image-placeholder:last-child {
  bottom: 0;
  right: 0;
}
.images-container.multiple img {
  object-fit: contain;
}
.images-container.single:not(.multiple) .image-placeholder {
  width: 100%;
  height: 100%;
}
.image-placeholder img {
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
}
.image-placeholder img.flight {
  object-fit: contain;
}
.align-right {
  height: 44px;
  justify-content: flex-end;
}
.price {
  border-right: 1px solid #f1f1f1;
  padding-right: 10px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.label {
  color: #a3abb6;
  font-size: 10px;
}
.value {
  font-size: 24px;
}

a {
  height: 100%;
}
.btn-action {
  padding: 12px 18px 10px 18px;
  font-size: 18px;
  height: 100%;
  border: 1px solid var(--btn-primary-color, hsl(208, 100%, 41%));
  border-radius: 10px;
  transition: all 0.05s ease-in-out;
  transition-property: color, background-color, border-color;
  background-color: var(--btn-primary-color, hsl(208, 100%, 41%));
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.btn-action:hover {
  background: #0061b6;
  border: 1px solid #0061b6;
  cursor: pointer;
}

.btn-action.outline {
  color: var(--btn-primary-color, hsl(208, 100%, 41%));
  background: none;
}

.btn-action.btn-details {
  background: #e4e4e4;
  color: #7a7a7a;
  border-color: #e4e4e4;
}

.icon-external-link {
  background-image: url(./icon-external-link.svg);
  background-width: 10px;
  background-position: center;
  background-repeat: no-repeat;
  height: 14px;
  width: 10px;
  margin-bottom: 4px;
}

.icon-check {
  height: 8px;
  width: 14px;
  position: relative;
  top: 1px;

  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 4L4.33333 7L11 1' stroke='%23006FCF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}

a:hover {
  text-decoration: none;
}

.booking-name {
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #071d3b;
}

.booking-unavailable {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #a4abb5;
}

.action-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.mark-as-booked {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: var(--btn-primary-color, hsl(208, 100%, 41%)) !important;
  margin-top: 5px;
}

.invisible {
  opacity: 0;
  pointer-events: none;
  cursor: default;
}
</style>
